let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aDvHP")).then(() => parcelRequire('9MD8s'));